import { useMutation } from '@apollo/client'
import { SetAntigenTypeTestSession, SetAntigenTypeTestSessionVariables } from '../../types'
import { SET_ANTIGEN_TYPE } from './operations'

export const useSetAntigenTypeTestSession = () =>
  useMutation<SetAntigenTypeTestSession, SetAntigenTypeTestSessionVariables>(SET_ANTIGEN_TYPE)
